<template>
  <div>
    <v-row
      no-gutters
      class="header-do-perfil parallax"
      id="header-do-perfil"
    >
      <ProfileHeader
        class="fade-in-top"
        v-if="userProfile"
        :profile="userProfile"
        role="professor"
      />
    </v-row>
    <div class="teacher-app-bg parallax" id="teacher-app-bg">
      <v-app-bar
        class=""
        app
        color="#350078"
        dark
        style="margin: 0 auto; box-shadow: none;"
      >
        <v-btn @click="drawer = !drawer" icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <img
          src="../assets_aluno/logotipo_cem_branco2.svg"
          class="logo-navbar"
        />
      </v-app-bar>
      <TeacherDrawer
        @closed="drawer = $event"
        :visibility="drawer"
      ></TeacherDrawer>
      <div class="parallax-over-header">
        <v-row no-gutters class="agenda-day mx-auto" id="" align-center>
          <v-col
            cols="12"
            class="agenda-title text-truncate fade-in-top animation-delay-2"
            >SUA AGENDA</v-col
          >

          <v-col
            cols="1"
            @click="beforeDay"
            class="fade-in-top animation-delay-2"
          >
            <v-icon size="86" class="agenda-day-arrow ">mdi-menu-left</v-icon>
          </v-col>

          <v-col cols="10" class="fade-in-top animation-delay-2">
            <div class="agenda-day-title text-truncate">
              {{ dayText }}<br /><span
                >{{ `${currentDate.getDate()}`.padStart(2, "0") }}/{{
                  `${currentDate.getMonth() + 1}`.padStart(2, "0")
                }}</span
              >
            </div>
          </v-col>

          <v-col
            cols="1"
            class="text-right fade-in-top animation-delay-2"
            @click="nextDay"
          >
            <v-icon size="86" class="agenda-day-arrow ">mdi-menu-right</v-icon>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          class="classes-list-agenda mx-auto fade-in-top animation-delay-3"
          id="classes-list-agenda"
        >
          <v-col cols="12" class="text-center">
            <v-btn-toggle
              v-model="selectedTab"
              rounded
              mandatory
              class="btn-toggle-purple"
            >
              <v-btn text value="1">
                Todos horários
              </v-btn>
              <v-btn text value="2">
                Aulas Marcadas
              </v-btn>
            </v-btn-toggle>
          </v-col>

          <v-card
            class="mx-auto classes-list-agenda-card mt-8"
            flat
            tile
            style="width: 100%;"
          >
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime8"
              hour="08"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime9"
              hour="09"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime10"
              hour="10"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime11"
              hour="11"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime12"
              hour="12"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime13"
              hour="13"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime14"
              hour="14"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime15"
              hour="15"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime16"
              hour="16"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime17"
              hour="17"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime18"
              hour="18"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime19"
              hour="19"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime20"
              hour="20"
              :date="currentDate"
            ></AgendaItem>
            <AgendaItem
              @clicked="openTeacherClassDialog"
              :selectedTab="selectedTab"
              :freeTime="freeTime21"
              hour="21"
              :date="currentDate"
            ></AgendaItem>
          </v-card>
          <div class="agenda-day-subtitle">
            <br /><br />
            Clique em um horário da<br />agenda para ver detalhes
          </div>
          <TeacherClassDialog
            ref="teacherClassDialog"
            :visibility="dialog"
            :date-formatted="dateFormatted"
            :date="date"
            @close="dialog = false"
          />
        </v-row>
        <EditProfessorDialog
          :visibility="edit"
          @negative="edit = !edit"
          @positive="onProfessorEdit"
          :profile="userProfile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileServiceMixin from "@/mixins/services/ProfileServiceMixin";
import ProfileHeader from "@/components/profile/ProfileHeader";
import AgendaItem from "@/components/teacher/AgendaItem";
import TeacherClassDialog from "@/components/dialogs/TeacherClassDialog";
import EditProfessorDialog from "@/components/dialogs/EditProfessorDialog";
import TeacherDrawer from "@/components/drawers/TeacherDrawer";
import DayOffRepository from "@/repositories/DayOffRepository";


import { mapState } from "vuex";

export default {
  components: {
    ProfileHeader,
    AgendaItem,
    TeacherClassDialog,
    EditProfessorDialog,
    TeacherDrawer
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      modal: undefined,
      drawer: undefined,
      edit: undefined,
      dialog: undefined,
      selectedTab: undefined,
      menu1: false,
      menu2: false,
      currentDate: new Date(),
      dropdown_edit: [
        { text: "10:00" },
        { text: "11:00" },
        { text: "12:00" },
        { text: "13:00" },
        { text: "14:00" },
        { text: "15:00" },
        { text: "16:00" },
        { text: "17:00" },
        { text: "18:00" },
        { text: "19:00" }
      ],

      isDayOff: false,
      dayOffName: undefined
    };
  },
  computed: {
    freeTime8() {
      const freeTime = this.availableFreeTime("08");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime9() {
      const freeTime = this.availableFreeTime("09");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime10() {
      const freeTime = this.availableFreeTime("10");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime11() {
      const freeTime = this.availableFreeTime("11");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime12() {
      const freeTime = this.availableFreeTime("12");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime13() {
      const freeTime = this.availableFreeTime("13");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime14() {
      const freeTime = this.availableFreeTime("14");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime15() {
      const freeTime = this.availableFreeTime("15");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime16() {
      const freeTime = this.availableFreeTime("16");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime17() {
      const freeTime = this.availableFreeTime("17");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime18() {
      const freeTime = this.availableFreeTime("18");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime19() {
      const freeTime = this.availableFreeTime("19");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime20() {
      const freeTime = this.availableFreeTime("20");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    freeTime21() {
      const freeTime = this.availableFreeTime("21");
      return { class: this.listItemClass(freeTime), freeTime: freeTime };
    },
    currentWeekday() {
      return this.currentDate
        .toLocaleString("en", { weekday: "long"})
        .toLowerCase();
    },
    getCurrentFreeTimes() {
      return this.freeTimes.filter(
        freeTime => this.currentWeekday === freeTime.week_day
      );
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    dayText() {
      if (this.isToday(this.currentDate)) return "Hoje";
      if (this.isTomorrow(this.currentDate)) return "Amanhã";

      return this.currentDate
        .toLocaleString('pt-BR', { weekday: "long"})
        .split("-")[0];
    },
    filterTimes() {
      [];
    },
    ...mapState(["userProfile", "allocatedClasses", "freeTimes"])
  },
  beforeMount() {
    this.$store.dispatch("loadProfessorStore");
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    selectedTab() {}
  },

  mounted() {

    this.dateIsDayOff()
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    isToday(date) {
      return new Date(date).toDateString() === new Date().toDateString();
    },
    isTomorrow(date) {
      let compareDate = new Date(date);
      let today = new Date();
      let tomorrow = new Date(today.getTime() + 86400000);
      return compareDate.toDateString() === tomorrow.toDateString();
    },
    nextDay() {
      this.currentDate = new Date(this.currentDate.getTime() + 86400000);
    },
    beforeDay() {
      let newDate = new Date(this.currentDate.getTime() - 86400000);
      let today = new Date();

      // if (newDate.getTime() >= today.getTime()) {
      this.currentDate = newDate;
      // }
    },
    availableFreeTime(start) {
      if ( (!this.getCurrentFreeTimes || this.getCurrentFreeTimes.length < 1) || this.isDayOff)
        return false;

      return this.getCurrentFreeTimes.find(
        freeTime => String(freeTime.start_at) === String(start)
      );
    },
    listItemClass(freeTime) {
      return {
        "class-canceled": freeTime ? (freeTime.cancel ? true : false) : false,
        "class-impossible": !freeTime
      };
    },

    openTeacherClassDialog(event) {
      this.$refs.teacherClassDialog.open(event);

    },

    onProfessorEdit(event) {
      this.edit = !this.edit;
    },

    async dateIsDayOff() {

      let response = await DayOffRepository.isDayOff( 'presential', this.date )
      this.isDayOff = response.data.is_day_off
      this.dayOffName = response.data.is_day_off ? response.data.day_off.description : ''
    }
  }
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:700&display=swap"); */
.teacher-app-bg {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 90px;
  background: rgba(244, 244, 252, 1);
  background: -moz-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(244, 244, 252, 1)),
    color-stop(100%, rgba(240, 240, 250, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(243, 243, 251, 11) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f4f4fc', endColorstr='#f0f0fa', GradientType=0 );
}

.logo-navbar {
  height: 90%;
}

.header-do-perfil {
  padding: 16px 20px 46px;
  background-color: #350078;
}
.foto-do-perfil {
  height: 100%;
  width: 100%;
  background-image: url("../assets_aluno/galileo_3.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid #ffffff;
}
p.nome-do-aluno {
  color: #44ff99;
  text-transform: uppercase;
  font-weight: 900;
  margin-bottom: 0;
  padding-left: 16px;
}
p.dados-do-aluno {
  line-height: 2;
  color: #ffffff;
  font-size: 11px;
  margin: 0;
  font-weight: 700;
  padding-left: 16px;
}

.agenda-day {
  padding: 42px 32px 18px;
  max-width: 460px;
}
.agenda-title {
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  color: #440099;
  letter-spacing: 7px;
  font-style: italic;
  margin-bottom: 24px;
  font-weight: 400;
}
.agenda-day-title {
  text-align: center;
  text-transform: uppercase;
  color: #440099;
  font-weight: 900;
  font-size: 38px;
  line-height: 1.1;
}
.agenda-day-title span {
  font-weight: 400;
  font-style: italic;
}
.agenda-day-arrow {
  width: 30px;
  color: #32e382;
  cursor: pointer;
}
.agenda-day-arrow.arrow-disabled {
  color: #d1c8de;
}

.btn-toggle-purple >>> .v-btn {
  font-weight: 700;
  color: #a09aab;
  border: 1px solid #440099 !important;
  font-size: 11px;
  height: 42px;
}
.btn-toggle-purple >>> .v-btn.v-item--active.v-btn--active {
  border: 1px solid #440099 !important;
  color: #440099;
  transition: 0.2s;
}
.btn-toggle-purple >>> .v-btn.v-item--active.v-btn--active::before {
  opacity: 0;
}

.agenda-day-subtitle {
  text-align: center;
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  margin: 0 auto 18px;
  text-transform: uppercase;
}
.classes-list-agenda {
  padding: 32px;
  position: relative;
  max-width: 640px;
}
.classes-list-agenda-card {
  position: relative;
  display: inline;
  box-shadow: 0 3px 12px 1px rgba(10, 5, 18, 0.1);
}
.classes-list-agenda-item {
  padding-left: 0;
  border-bottom: 1px solid #f0f0f0;
  min-height: 64px;
}
.classes-list-agenda-color {
  position: absolute;
  width: 6px;
  height: 100%;
  background-color: #e2dfe8;
}
.classes-list-agenda-time {
  display: inline-flex;
  min-width: 80px;
  padding: 0 9px 0 21px;
  font-weight: 700;
  color: #c2bfc7;
  text-align: center;
}
.classes-list-agenda-title {
  color: #a09aab;
  font-weight: 400;
  text-transform: none;
}
.classes-list-agenda-title span {
  font-weight: 400;
  color: #a09aab;
  text-transform: capitalize;
}
.v-list-item__subtitle.classes-list-agenda-subtitle {
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  font-style: italic;
}

.classes-list-agenda-item.class-confirmed div.classes-list-agenda-color {
  background-color: #44ff99;
}
.classes-list-agenda-item.class-confirmed div.classes-list-agenda-time {
  color: #440099;
}
.classes-list-agenda-item.class-confirmed
  div.v-list-item__title.classes-list-agenda-title {
  color: #440099;
  font-weight: 700;
  text-transform: uppercase;
}
.classes-list-agenda-item.class-confirmed
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #440099;
}

.classes-list-agenda-item.class-impossible {
  background-color: #f4f3f5;
}
.classes-list-agenda-item.class-impossible:active {
  background-color: #fafafa;
}
.classes-list-agenda-item.class-impossible div.classes-list-agenda-color {
  background-color: #c2bfc7;
}
.classes-list-agenda-item.class-impossible div.classes-list-agenda-time {
  color: #c2bfc7;
}
.classes-list-agenda-item.class-impossible
  div.v-list-item__title.classes-list-agenda-title {
  color: #c2bfc7;
  font-weight: 400;
}
.classes-list-agenda-item.class-impossible
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #c2bfc7;
}

.classes-list-agenda-item.class-canceled div.classes-list-agenda-color {
  background-color: #ff3d00;
}
.classes-list-agenda-item.class-canceled div.classes-list-agenda-time {
  color: #ff3d00;
}
.classes-list-agenda-item.class-canceled
  div.v-list-item__title.classes-list-agenda-title {
  color: #ff3d00;
  font-weight: 400;
}
.classes-list-agenda-item.class-canceled
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #c2bfc7;
}

.dialog-subtitle {
  text-align: center;
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  text-transform: uppercase;
}
.big-purple-date-picker.theme--light.v-text-field.v-text-field--is-booted
  >>> input {
  text-align: right;
  color: #440099;
  font-size: 26px;
  font-weight: 900;
  margin: 0 auto;
}
.big-purple-date-picker.theme--light.v-text-field >>> .v-input__slot::before {
  border-top: none;
}
.big-purple-date-picker.theme--light.v-text-field >>> .v-input__slot,
.big-purple-date-picker >>> .theme--light.v-messages {
  margin: 0;
  color: #a09aab;
  text-transform: uppercase;
}
div.big-purple-date-picker >>> div.v-text-field__details {
  text-align: center;
}
.v-input.big-purple-time-picker >>> .v-input__slot {
  margin-bottom: 30px;
}
.v-input.big-purple-time-picker.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted.v-select.v-autocomplete.v-overflow-btn.v-overflow-btn--editable
  >>> input {
  text-align: right;
  color: #440099;
  font-size: 26px;
  max-width: 200px;
  font-weight: 900;
  margin: 0 auto;
}
div.big-purple-time-picker.v-input.big-purple-time-picker.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted.v-select.v-autocomplete.v-overflow-btn.v-overflow-btn--editable
  >>> ::before,
div.big-purple-date-picker
  >>> i.v-icon.notranslate.mdi.mdi-menu-down.theme--light {
  background-color: rgba(0, 0, 0, 0) !important;
  border: none;
  color: #440099;
  transform: scale(2);
  max-width: 150px;
  text-align: right;
  margin: 0 auto;
}

.header-do-perfil.parallax {
  position: fixed;
  left: 0;
  top: 56px;
  right: 0;
  z-index: 1;
  height: 100%;
}
.teacher-app-bg.parallax {
  z-index: 2;
  position: absolute;
  top: 153px;
  box-shadow: 0 0 15px 15px rgba(20, 10, 30, 0.2);
  border-top: 1px solid #ffffff;
}

.fade-in-top {
  -webkit-animation: fade-in-top 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-top 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
@-webkit-keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
.animation-delay-2 {
  animation-delay: 400ms;
}
.animation-delay-3 {
  animation-delay: 600ms;
}
</style>
